import i18next from 'i18next';
import {subscriptionService} from '../_services';
import {alertActions} from './';
import {subscriptionActionTypes} from "../_constants/actions/subscriptionActionTypes";
import {notificationConstants} from "../_constants";
import {userHelper} from "../_helpers";

export const subscriptionActions = {
    subscribe,
    getSubscription
};

/**
 * Redux Action that accepts plan-uuid and initiates subscribe process to the plan
 *
 * @param plan the plan containing name and uuid
 * @return {function(...[*]=)}
 */
function subscribe(plan) {
    return dispatch => {

        // utility constants - contains all module-related dispatches from this function
        const dispatchRequestStarted = () => dispatch({ type: subscriptionActionTypes.SUBSCRIBE_REQUEST });
        const dispatchRequestSuccess = (subscription) => dispatch({ type: subscriptionActionTypes.SUBSCRIBE_SUCCESS, subscription });
        const dispatchRequestError   = () => dispatch({ type: subscriptionActionTypes.SUBSCRIBE_FAILURE });

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        subscriptionService.subscribe(plan)
            .then(
                subscription => {
                    if( subscription ){
                        // dispatch a success if the service succeeds in switching sub
                        dispatchRequestSuccess(subscription);
                        
                        const t = i18next.t;
                        const message = {
                            "successMsg": t("Subscribed to ", {planName: plan.NAME}),
                            "redirectParams": {
                                "redirectTo": "/media"
                            },
                            "toastParams": {
                                "toastType": notificationConstants.NOTIFICATION_TYPES.SUCCESS
                            },
                        }
                        dispatch(alertActions.success(message));
                    }
                },
                error => {
                    // dispatch a failure
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                }
            );
    };
}

/**
 * Redux Action that fetches the subscription of the user
 *
 * @returns {Function}
 */
function getSubscription() {
    const t = i18next.t;
    
    return dispatch => {
        // utility constants
        const dispatchRequestStarted = () => dispatch({type: subscriptionActionTypes.GET_SUBSCRIPTION_REQUEST});
        const dispatchRequestSuccess = (subscriptions) => dispatch({type: subscriptionActionTypes.GET_SUBSCRIPTION_SUCCESS, subscriptions});
        const dispatchRequestError = () => dispatch({type: subscriptionActionTypes.GET_SUBSCRIPTION_FAILURE});
        
        // dispatch the subscription is being checked
        dispatchRequestStarted();
        
        // delegate the API request to the service
        subscriptionService.getSubscriptions()
                .then(subscriptions => {
                    if( Array.isArray(subscriptions) && subscriptions.length === 0 ) {   // if no active subscription
                        // if subscription is empty then redirect to pricing page
                        let res = {
                            "status": 402,
                            "errorMsg": t("Upgrade your subscription to use the features."),
                            "toastParams": {
                                "toastType": notificationConstants.NOTIFICATION_TYPES.ERROR,
                                "toastPersistence": true,
                            },
                            "redirectParams": {
                                "redirectTo": "/pricing",
                                "isExternal": true,
                            }
                        };
                        dispatch(alertActions.error(res));
                    } else if ( userHelper.isSubscriptionInGracePeriod(subscriptions) ) {
                        // if outstanding payment on the subscription
                        let res = {
                            "status": 402,
                            "errorMsg": t("There’s a billing issue with your account. Try updating your payment info."),
                            "toastParams": {
                                "toastType": notificationConstants.NOTIFICATION_TYPES.WARN,
                                "toastPersistence": true,
                            },
                        };
                        dispatch(alertActions.error(res));
                    }
                    
                    // success
                    dispatchRequestSuccess(subscriptions);
                },
                error => {
                    // dispatch a failure
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                });
    };
}